import React, { useContext } from 'react';
import { RendererContext } from '../../context';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import Link from '@atlaskit/link';

type EgressErrorMessageProps = {
	url: string;
};

export const EgressErrorMessage = ({ url }: EgressErrorMessageProps) => {
	const { forgeEnvironment } = useContext(RendererContext);
	const dataUriRegex = /^data/;
	const isDataUri = dataUriRegex.test(url);

	if (forgeEnvironment === 'DEVELOPMENT') {
		return (
			<SectionMessage appearance="error" testId="egress-error-message">
				{isDataUri ? (
					<Text>
						Please use the <Text as="strong">data:image</Text> scheme for an image source.
					</Text>
				) : (
					<Text>
						Egress permissions for{' '}
						<Link href={url} target="_blank">
							{url}
						</Link>{' '}
						missing in the manifest. For more information{' '}
						<Link
							href="https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images"
							target="_blank"
						>
							see reference docs
						</Link>
						.
					</Text>
				)}
			</SectionMessage>
		);
	}

	return (
		<SectionMessage appearance="error">
			Unable to display due to an image link issue.
		</SectionMessage>
	);
};
